import styles from "./AnalysisMetricSelector.module.css";

import Selector, {SelectorItems} from "./Selector";
import DropdownSelector, {DropdownSelectorItems} from "./DropdownSelector";


interface analysisMetricSelectorProps {
    analysisType: number;
    selectorItems: SelectorItems[];
    dropdownSelectorItems: DropdownSelectorItems[];
    selectedKey: string;
    onChange: (key: string) => void;
    onMouseOver?: (key: string) => void;
    onMouseOut?: () => void;
    isReverse?: boolean;
    loadingMetricKey?: boolean;

    // 25.07.03 | Kim Young Jun | setIsLoading, setLoadingMessage 추가
    setIsLoading: (isLoading: boolean) => void;
    setLoadingMessage: (message: string) => void;

    triggerAnalysis?: () => void; // 25.07.07 | Kim Young Jun | 동일 매트릭 선택 시에도 분석 동작하도록 상태 추가
}

function AnalysisMetricSelector(props: analysisMetricSelectorProps){
    return (
        <div className={styles.selector_container}>
            <Selector
                items={props.selectorItems}
                selectedKey={props.selectedKey}
                onChange={props.onChange}
                isReverse={props.isReverse}
                onMouseOver={props.onMouseOver}
                onMouseOut={props.onMouseOut}
            />
            <DropdownSelector
                analysisType={props.analysisType}
                items={props.dropdownSelectorItems}
                selectedKey={props.selectedKey}
                onChange={props.onChange}
                isReverse={!props.isReverse}
                onMouseOver={props.onMouseOver}
                onMouseOut={props.onMouseOut}

                // 25.07.03 | Kim Young Jun | setIsLoading, setLoadingMessage 추가
                setIsLoading={props.setIsLoading}
                setLoadingMessage={props.setLoadingMessage}

                triggerAnalysis={props.triggerAnalysis} // 25.07.07 | Kim Young Jun | 동일 매트릭 선택 시에도 분석 동작하도록 상태 추가
            />
        </div>
    )
}


export default AnalysisMetricSelector;